import React from 'react';

export const Button = ({
    children = <>Button</>,
    onClick,
    ...rest
}) => {
    return (
        <button
            className='primary__btn'
            onClick={onClick}
            {...rest}
            >
            {children}
        </button>
    )
}